/**
 * "More payment options" href fix.
 *
 * Shopify's dynamic-checkout SDK injects
 *   <a href="#" id="...more-payment-options-link" class="shopify-payment-button__more-options">
 * inside {{ form | payment_button }}. The markup is platform-rendered, so the
 * anchor cannot be changed to a <button> in Liquid, and replacing the node in
 * JS would sever the SDK's click listener (see the cloneNode anti-pattern in
 * project memory). Instead we give the anchor a real destination: the SDK's
 * handler still preventDefaults and opens the payment sheet on click, while
 * a11y audits, dead-click tracking, and any handler failure now resolve to
 * /cart instead of href="#" (which scrolls to top and registers as a dead
 * click).
 *
 * The SDK mounts asynchronously (and more than one payment button can mount
 * at different times), so we observe the DOM for a bounded 20s window and
 * patch every matching anchor that appears, then disconnect.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  var cartUrl = (script && script.dataset.cartUrl) || '/cart';

  function patch() {
    var links = document.querySelectorAll(
      'a[id*="more-payment-options-link"], a.shopify-payment-button__more-options'
    );
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href || href === '#') {
        links[i].setAttribute('href', cartUrl);
      }
    }
  }

  function start() {
    patch();

    // Keep observing for the full window: payment buttons can mount at
    // different times (main form, sticky bar, quick-view), so disconnecting
    // on first success would miss later-mounting anchors.
    var observer = new MutationObserver(patch);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
